import React from 'react';
import CaseTitle from "../../../common/components/CaseTitle";
import CorrectiveEventsContainer from "../../../common/components/CorrectiveEvent/CorrectiveEventsContainer";
import ArtificialInflationGraphContainer
    from "../../../common/components/ArtificialInflationGraph/ArtificialInflationGraphContainer";
import ClassPeriodTradingStatContainer
    from "../../../common/components/ClassPeriodTradingStat/ClassPeriodTradingStatContainer";
import MarketCapLossesContainer
    from "../../../common/components/MarketCapLosses/MarketCapLossesContainer";
import DollarValueInflationContainer
    from "../../../common/components/DollarValueInflation/DollarValueInflationContainer";
import StatAnalysisContainer from "../../../common/components/StatAnalysis/StatAnalysisContainer";
import PrelimDamagesContainer from "../../../common/components/PrelimDamages/PrelimDamagesContainer";

import "./CommissionDamagesComponent.css"
import {COMMISSION_REPORT_TYPE} from "../../../common/components/PrintReport/PrintReport";
import PrintReport from "../../../common/components/PrintReport/PrintReport";

const CommissionDamagesComponent = (props) => {

    let tables = <div className={"CorrectiveInfoText"}>Max. Aggregate Damages of Class-wide Damages has not been
        finalized.</div>;

    let print = <div/>;
    let correctiveEvents = <div/>;

    if (props.commissionStatus === 'COMPLETED') {
        tables = <React.Fragment>
            <ClassPeriodTradingStatContainer classPeriodTradingStats={props.classPeriodTradingStats}/>
            <MarketCapLossesContainer marketCapitalizationLosses={props.marketCapitalizationLosses}/>
            <StatAnalysisContainer statResidualReturns={props.statResidualReturns}/>
            <DollarValueInflationContainer dollarValueInflations={props.dollarValueInflations}/>
            <PrelimDamagesContainer aggregateDamages={props.aggregateDamages}/>
            <ArtificialInflationGraphContainer 
            stockPrices={props.stockPrices} 
            aggregateDamagesNOPSLRA={props.aggregateDamagesNOPSLRA}/>
        </React.Fragment>;

        correctiveEvents = <CorrectiveEventsContainer correctiveEvents={props.correctiveEvents}
                                                      ticker={props.ticker}
                                                      dateCommissioned={props.dateCommissioned}
                                                      lastUpdate={props.lastUpdate}
                                                      classPeriodStart={props.classPeriodStart}
                                                      classPeriodEnd={props.classPeriodEnd} />

        print = <PrintReport classPeriodTradingStats={props.classPeriodTradingStats}
                             marketCapitalizationLosses={props.marketCapitalizationLosses}
                             statResidualReturns={props.statResidualReturns}
                             dollarValueInflations={props.dollarValueInflations}
                             aggregateDamages={props.aggregateDamages}
                             currentCaseId={props.currentCaseId}
                             currentFillingName={props.currentFillingName}
                             commissionName={props.commissionName}
                             type={COMMISSION_REPORT_TYPE}
                             correctiveEvents={correctiveEvents}
                             stockPrices={props.stockPrices}
        />;
    } else if (props.commissionStatus === 'REJECTED') {
        tables = <div className={"CorrectiveInfoText"}>
            {/*make link for info*/}
            Requested Max. Aggregate Damages Estimate of Class-wide Damages cannot be commissioned via the SCADA Platform. Please
            contact customer support at <a href={"mailto:info@sarlit.com"}>info@sarlit.com</a>
        </div>;
    }

    return (
        <React.Fragment>
            <div className={"nonePrinted"}>
                <CaseTitle caseName={props.commissionName}/>
                {correctiveEvents}
                {tables}
            </div>
            {print}
        </React.Fragment>
    );
};

export default CommissionDamagesComponent;


// WEBPACK FOOTER //
// ./src/commissions/components/damages/CommissionDamagesComponent.js